import React, { Component } from 'react'
import Link, { navigate } from 'gatsby-link'
import logo from '../images/benetic_logo_small.png'

import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'

function initNetlifyIdentity() {
  console.log("initNetlifyIdentity was called")
  const script = document.createElement("script");

  script.src = "https://identity.netlify.com/v1/netlify-identity-widget.js"
  script.async = true;

  document.body.appendChild(script)
}

function openNetlifyModal() {
  const netlifyIdentity = window.netlifyIdentity;

  if(netlifyIdentity) {
    netlifyIdentity.open()
    netlifyIdentity.on("login", (user) => {
      console.log('welcome', user)
      navigate("https://web.prod.benetic.com/login")
    })
  } else {
      console.log("netlifyIdentity not defined")
    }  
  }

  class NetlifyIdentity extends Component {
    componentDidMount() {
      initNetlifyIdentity();
    }
  
    render() {
      return (<div></div>)
    }
  }


  function Navigation() {
    return (
        <Container className="pl-auto nav-container"fluid={true} >
          <NetlifyIdentity />
        <Navbar expand="lg">
            <Link to="/" ><img src={logo} alt="logo" /></Link>
            <Navbar.Toggle className="border-0" aria-controls="navbar-toggle" />
            <Navbar.Collapse id="navbarResponsive" >
                <Nav className="nav-container">
                    <Link className="nav-link p-4" to="/">Home</Link>
                    <Link className="nav-link p-4" to="/platform">Platform</Link>
                    <NavDropdown title="Solutions" className="nav-link p-3" id="basic-nav-dropdown">
                      <Link className="nav-link ml-3" style={{color: "#2a2a2a"}} to="/advisors">Advisors</Link>
                      <Link className="nav-link ml-3" style={{color: "#2a2a2a"}} to="/asset-managers">Asset Managers</Link>
                      <Link className="nav-link ml-3" style={{color: "#2a2a2a"}} to="/recordkeepers">Recordkeepers</Link>
                    </NavDropdown>
                      {/* <Link className="nav-link p-4" to="/company">Company</Link>
                      <Link className="nav-link p-4" to="/resources">Resources</Link> */}
                      <Link 
                        className="nav-link p-4" 
                        style={{color: "#2a2a2a", 
                        textDecoration: "none"}} 
                        className="auth-buttons"
                        onClick={() => { openNetlifyModal() }}
                        to="/"
                        >
                          Login
                      </Link>
                      <Link 
                        className="nav-link p-4" 
                        style={{color: "#2a2a2a", 
                        textDecoration: "none"}} 
                        className="login" 
                        onClick={() => { openNetlifyModal() }}
                        to="/">
                          Sign-up
                      </Link> 
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    </Container>
  )
}

export default Navigation